import { VosDienst } from "@/entities/dossier-overzicht";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components";
import { VosStatus } from "./icons";

type MedewerkersOpStationStatusEnTooltipProps = {
    dienst: VosDienst;
};

export function VosStatusEnTooltip({ dienst }: MedewerkersOpStationStatusEnTooltipProps) {
    const labels = [
        { label: "VOS aangevraagd", count: dienst.countByStatus?.AanvraagLoopt },
        { label: "VOS ingezet", count: dienst.countByStatus?.VosIngezet },
        { label: "geen VOS inzetbaar", count: dienst.countByStatus?.GeenVosInzetbaar },
        { label: "VOS gestopt", count: dienst.countByStatus?.Gestopt },
    ];

    return (
        <Tooltip key={dienst.type}>
            <TooltipTrigger data-testid="medewerkers-op-station-status">
                <VosStatus variant={dienst.variant} />
            </TooltipTrigger>
            <TooltipContent className="max-w-full">
                {labels
                    .filter(({ count }) => count && count > 0)
                    .map(({ label, count }) => (
                        <p key={label}>
                            {count} station{count === 1 ? "" : "s"} {label}
                        </p>
                    ))}
            </TooltipContent>
        </Tooltip>
    );
}
